module.exports = __webpack_public_path__ + "static/media/PY.33a767af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/PY.svg
// module id = 345
// module chunks = 0